import { Link } from 'react-router-dom';

interface SubprojectLinkProps {
  projectId: string | null | undefined;
  subprojectId: string | null | undefined;
  label: string;
  canNavigate: boolean;
  disabledTitle?: string;
  linkClassName?: string;
  textClassName?: string;
}

const DEFAULT_LINK_CLASS_NAME = 'text-blue-600 hover:underline focus-visible:outline-none focus-visible:underline';
const DEFAULT_TEXT_CLASS_NAME = 'text-gray-900';

export function SubprojectLink({
  projectId,
  subprojectId,
  label,
  canNavigate,
  disabledTitle,
  linkClassName = DEFAULT_LINK_CLASS_NAME,
  textClassName = DEFAULT_TEXT_CLASS_NAME,
}: SubprojectLinkProps) {
  const normalizedLabel = label.trim() || '—';
  const hasTarget = Boolean(projectId && subprojectId);
  const canRenderLink = canNavigate && hasTarget && normalizedLabel !== '—';

  if (!canRenderLink) {
    return (
      <span className={textClassName} title={disabledTitle}>
        {normalizedLabel}
      </span>
    );
  }

  return (
    <Link to={`/projects/${projectId}/subprojects/${subprojectId}`} className={linkClassName}>
      {normalizedLabel}
    </Link>
  );
}
